// extracted by mini-css-extract-plugin
export default {"container":"sections_container__sMPQG","sectionDevider":"sections_sectionDevider__HxlyR","sectionItems":"sections_sectionItems__Ktl+F","sectionItem":"sections_sectionItem__7RlZK"};